import { Button, buttonVariants } from '@/components/ui/elements/button';
import { Lead } from '@/types';
import { cn } from '@/utils/format';
import { FireIcon } from '@heroicons/react/24/solid';
import { VariantProps } from 'cva';
import { useFlagPriority } from '../hooks/useFlagPriority';

interface PriorityFlagProps {
  lead: Lead;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  size?: VariantProps<typeof buttonVariants>['size'];
}
export const PriorityFlag = ({ lead, variant = 'ghost', size = 'sm' }: PriorityFlagProps) => {
  const { flag } = useFlagPriority();

  return (
    <Button
      variant={variant}
      size={size}
      className="group"
      onClick={() => flag(lead.id, !lead.is_priority)}
    >
      <FireIcon
        className={cn(
          'text-foreground/40 group-hover:text-red-400 transition-colors',
          lead.is_priority ? 'text-red-500' : '',
        )}
      />
      <span className="sr-only">Toggle Priority Flag</span>
    </Button>
  );
};
